import * as React from 'react';
import * as elog from '@reverbdotcom/commons/dist/elog';
import { get } from 'lodash';
import bind from '@reverbdotcom/commons/dist/bind';
import { mountComponent } from '../adyen_checkout_mounter';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';

interface ExternalProps {
  fingerprintToken: string;
  onComplete: (fingerprintResult: string) => void;
  onError: (error: Error) => void;
}

export type IProps = ExternalProps & IUserContext;

export const DEVICE_FINGERPRINT_CONTAINER_ID = 'threeds2-fingerprint';

const TAG = 'adyen.threeds2_identify_shopper';

export class IdentifyShopper extends React.Component<IProps, null> {
  @bind
  onComplete(result) {
    const fingerprintResult = get(result, ['data', 'details', 'threeds2.fingerprint']);
    this.props.onComplete(fingerprintResult);
  }

  eventData(additionalContext = {}) {
    return {
      componentName: 'IdentifyShopper',
      context: {
        props: { ...this.props },
        ...additionalContext,
      },
    };
  }

  componentDidMount() {
    mountComponent({
      domSelector: `#${DEVICE_FINGERPRINT_CONTAINER_ID}`,
      type: 'threeDS2DeviceFingerprint',
      locale: this.props.user.locale,
      props: {
        fingerprintToken: this.props.fingerprintToken,
        onComplete: this.onComplete,
        onError: this.props.onError,
      },
    });
    elog.info(`${TAG}.mount`, { ...this.eventData() });
  }

  render() {
    return <div id={DEVICE_FINGERPRINT_CONTAINER_ID} />;
  }
}

export default withUserContext(IdentifyShopper);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/threeds2/identify_shopper.tsx